/* this file is transformed by vux-loader */
/* eslint-disable */
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import { getActivity as _getActivity } from '@/api/activity';
var errorLog = {
  state: {
    activityId: '',
    activity: {}
  },
  mutations: {
    GET_ACTIVITY: function GET_ACTIVITY(state, activity) {
      state.activityId = activity.id;
      state.activity = activity;
    }
  },
  actions: {
    getActivity: function () {
      var _getActivity2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref, params) {
        var commit, activity;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                _context.next = 3;
                return _getActivity(params);

              case 3:
                activity = _context.sent;
                commit('GET_ACTIVITY', activity);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function getActivity(_x, _x2) {
        return _getActivity2.apply(this, arguments);
      };
    }()
  }
};
export default errorLog;